module.exports = __webpack_public_path__ + "static/media/NJSpotlight_landing_ongradient.c7707381.svg";